export default __webpack_public_path__ + "static/media/icon-15.13d9ae60.png";